
    document.addEventListener('DOMContentLoaded', function () {
      class Backdrop {
        constructor() {
          this.backdropElement = null;
        }

        show(openedFrom, modalElement) {
          document.body.style.overflow = "hidden";
          this.backdropElement = document.createElement("div");
          this.backdropElement.style.cssText = "z-index: 20; position: fixed; width: 100%; height: 100%; background-color: #737373; opacity: 0.4; top: 0; left: 0;";
          this.backdropElement.setAttribute("data-backdropfor", openedFrom);
          this.backdropElement.setAttribute("backdrop", "");
          this.backdropElement.innerHTML = " ";
          
          this.backdropElement.addEventListener('click', (e) => {
            if (e.target === this.backdropElement) {
              console.log('Backdrop clicked, closing modal');
              if (modalElement) {
                modalElement.style.display = 'none';
                this.hide(openedFrom);
              }
            }
          });

          document.body.appendChild(this.backdropElement); // Append to body
        }
      
        hide(backdropfor) {
          if (this.backdropElement) {
            this.backdropElement.remove();
            this.backdropElement = null;
          }
          document.body.style.overflow = "initial";
        }
      }
      
      class Modal {
        constructor() {
          this.backdrop = new Backdrop();
          this.currentModal = null; // Track the open modal
          this.initialize();
        }

        open(e) {
          const triggerElement = e.target.closest('[modal-open]');
          if (!triggerElement) return;
          
          const modalId = triggerElement.dataset.modal;
          if (!modalId) return;
          
          const modalElement = document.getElementById(modalId);
          if (modalElement) {
            this.currentModal = modalElement;
            this.backdrop.show('modal', this.currentModal);
            modalElement.style.display = 'flex';
          }
        }

        close(e) {
          this.backdrop.hide('modal');
          const modal = e.target.closest('.modal');
          if (modal) {
            modal.style.display = 'none';
            if (modal === this.currentModal) {
              this.currentModal = null;
            }
          }
        }

        initialize() {
          document.addEventListener("click", (e) => {
            const modalOpen = e.target.closest('[modal-open]');
            if (modalOpen) {
              e.preventDefault();
              this.open(e);
            }
          });

          document.addEventListener("click", (e) => {
            const modalClose = e.target.closest('[modal-close]');
            if (modalClose) {
              e.preventDefault();
              this.close(e);
            }
          });
        }
      }

      new Modal();
    });